import api from '../api';

export async function fetchAppConfigs() {
  const { data } = await api.get('/app-configs');
  return data;
}
